import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS, HttpClientJsonpModule } from '@angular/common/http'
import { LOCALE_ID, NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { BrowserModule } from '@angular/platform-browser'
import { MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalInterceptor, MsalInterceptorConfiguration, MsalModule, MsalRedirectComponent, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular'
import { InteractionType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser'
import { TranslateLoader, TranslateModule } from '@ngx-translate/core'
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { SharedModule } from '@shared/shared.module'
import { NgxPaginationModule } from 'ngx-pagination'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { loginRequest, msalConfig, protectedResources } from './auth-config'
import { CatalogueManagementComponent } from './components/administration/catalogue-management/catalogue-management.component'
import { ClientComponent } from './components/administration/client/client.component'
import { ClientNewUpdateComponent } from './components/administration/client/modals/client-new-update/client-new-update.component'
import { UserAdministrationComponent } from './components/administration/user-administration/user-administration.component'
import { FilterPlateComponent } from './components/dashboards/filter-plate/filter-plate.component'
import { MainDashboardComponent } from './components/dashboards/main-dashboard/main-dashboard.component'
import { PlantEfficiencyDashboardComponent } from './components/dashboards/plant-efficiency-dashboard/plant-efficiency-dashboard.component'
import { DetailTruckComponent } from './components/dashboards/real-time-dashboard/detail-real-time-dashboard/detail-truck/detail-truck.component'
import { RealTimeDashboardComponent } from './components/dashboards/real-time-dashboard/real-time-dashboard.component'
import { ListPlatesComponent } from './components/dashboards/shared/list-plates/list-plates.component'
import { TripDetailRealTimeComponent } from './components/dashboards/shared/trip-detail-real-time/trip-detail-real-time.component'
import { TripDetailRtComponent } from './components/dashboards/shared/trip-detail-rt/trip-detail-rt.component'
import { TripDetailComponent } from './components/dashboards/shared/trip-detail/trip-detail.component'
import { TruckEfficiencyDashboardComponent } from './components/dashboards/truck-efficiency-dashboard/truck-efficiency-dashboard.component'
import { FooterComponent } from './components/shared/footer/footer.component'
import { HeaderComponent } from './components/shared/header/header.component'
import { NotFoundComponent } from './components/shared/not-found/not-found.component'
import { SidenavComponent } from './components/shared/sidenav/sidenav.component'
import { UserDataModule } from './components/shared/user-data/user-data/user-data.module'
import { BrokenImageDirective } from './directives/broken-image.directive'
import { OrdinalDatePipe } from './pipes/ordinal-date.pipe';
import { VehicleComponent } from './components/administration/vehicle/vehicle.component';
import { TotalCountryDashboardComponent } from './components/dashboards/total-country-dashboard/total-country-dashboard.component';
import { HealthSafetyDashboardComponent } from './components/dashboards/health-safety-dashboard/health-safety-dashboard.component';
import { HealthSafetyControlTowerDashboardComponent } from './components/dashboards/health-safety-control-tower-dashboard/health-safety-control-tower-dashboard.component';
import { MinidashboardComponent } from './components/dashboards/minidashboard/minidashboard.component';
import { MinidashboardDzComponent } from './components/dashboards/minidashboard-dz/minidashboard-dz.component';
import { MinidashboardPpeComponent } from './components/dashboards/minidashboard-ppe/minidashboard-ppe.component';
import { MinidashboardUserComponent } from './components/dashboards/minidashboard-user/minidashboard-user.component';
import { MinidashboardEnvaseComponent } from './components/dashboards/minidashboard-envase/minidashboard-envase.component';
import { MinidashboardMateriasPrimasComponent } from './components/dashboards/minidashboard-materias-primas/minidashboard-materias-primas.component';
import { MinidashboardUserDzComponent } from './components/dashboards/minidashboard-user-dz/minidashboard-user-dz.component';

import { GridComponent } from './components/shared/grid/grid.component';
import { MaterialModule } from '@modules/material/material.module';
import { IncidentRecordComponent } from './components/dashboards/health-safety-control-tower-dashboard/detail-health-safety-control-tower-dashboard/incident-record/incident-record.component';
import { CarouselIncidentRecordComponent } from './components/dashboards/health-safety-control-tower-dashboard/detail-health-safety-control-tower-dashboard/carousel-incident-record/carousel-incident-record.component'
import { NgImageSliderModule } from 'ng-image-slider';
import { RejectIncidentsComponent } from './components/dashboards/health-safety-control-tower-dashboard/detail-health-safety-control-tower-dashboard/reject-incidents/reject-incidents.component'
import { LayoutModule } from '@angular/cdk/layout';
import { IncidentHealthSafetyControlTowerComponent } from './components/dashboards/health-safety-control-tower-dashboard/incident-health-safety-control-tower/incident-health-safety-control-tower.component';

import {MatTabsModule as MatTabsModule} from '@angular/material/tabs';
import { IncidentFormComponent } from './components/dashboards/health-safety-control-tower-dashboard/incident-form/incident-form.component';
import { DialogFormConfirmComponent } from './components/dashboards/health-safety-control-tower-dashboard/dialog-form-confirm/dialog-form-confirm.component';
import { MatDialog as MatDialog, MatDialogActions as MatDialogActions, MatDialogClose as MatDialogClose, MatDialogContent as MatDialogContent, MatDialogModule, MatDialogRef as MatDialogRef, MatDialogTitle as MatDialogTitle } from '@angular/material/dialog'

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';

import { ReasonSendMessageComponent } from './components/dashboards/health-safety-control-tower-dashboard/detail-health-safety-control-tower-dashboard/reason-send-message/reason-send-message.component';


import { CommonModule } from '@angular/common'
import { MatSnackBarModule as MatSnackBarModule } from '@angular/material/snack-bar';


import { DialogIncidentCloseComponent } from './components/dashboards/health-safety-control-tower-dashboard/dialog-incident-close/dialog-incident-close.component'
import { DeviceManagementComponent } from './components/administration/device-management/device-management.component';
import { ModalReportingFieldsComponent } from './components/administration/device-management/modal-reporting-fields/modal-reporting-fields.component'
import { StatusCctvComponent } from './components/administration/status-cctv/status-cctv.component';
import { FieldServiceReviewComponent } from './components/administration/field-service-review/field-service-review.component';
import { ModalReportFormEditComponent } from './components/administration/field-service-review/modal-report-form-edit/modal-report-form-edit.component';
import { FilterComponentComponent } from './components/shared/grid/filter-component/filter-component.component';
// import { provideClarity } from 'ngx-clarity';
import { MatButtonModule } from '@angular/material/button'
import { DevicesAvailabilityComponent } from './components/administration/devices-availability/devices-availability.component'
import { GoogleMapsModule } from '@angular/google-maps'
import { PerformanceMonitoringComponent } from './components/administration/performance-monitoring/performance-monitoring.component'
import { ModalPerformanceMonitoringComponent } from './components/administration/performance-monitoring/modal-performance-monitoring/modal-performance-monitoring.component'
import { CookieService } from 'ngx-cookie-service';
import { AISettingsCameraControlComponent } from './components/administration/aisettings-camera-control/aisettings-camera-control.component';
import { SettingsCameraComponent } from './components/administration/aisettings-camera-control/settings-camera/settings-camera.component'
import { ModalSettingsCameraComponent } from './components/administration/aisettings-camera-control/modal-settings-camera/modal-settings-camera.component'
import { MatRadioModule } from '@angular/material/radio';

import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatChipsModule } from '@angular/material/chips'
import { MatIconModule } from '@angular/material/icon'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { ModalPauseAlertComponent } from './components/administration/aisettings-camera-control/modal-pause-alert/modal-pause-alert.component'

import { CatalogueDevicesComponent } from './components/administration/catalogue-devices/catalogue-devices.component'
import { SaveDeviceComponent } from './components/administration/catalogue-devices/save-device/save-device.component';
import { ConfirmDialogComponent } from './components/administration/catalogue-devices/confirm-dialog/confirm-dialog.component'

import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { ConfirmDialogAlertsComponent } from './components/administration/aisettings-camera-control/confirm-dialog-alerts/confirm-dialog-alerts.component'
import { SettingsUpdateDevicesComponent } from './components/administration/aisettings-camera-control/settings-update-devices/settings-update-devices.component'


import { OrderByPipe } from './pipes/order-by.pipe'
import { NotificationsMiniAreaComponent } from './components/shared/notifications-mini-area/notifications-mini-area.component'
import { NotificationsBoxAreaComponent } from './components/shared/notifications-box-area/notifications-box-area.component'
import { NgxUiLoaderConfig, NgxUiLoaderModule } from 'ngx-ui-loader'
import { LoadingInterceptor } from './interceptors/loadinginterceptor'

import { DashboardComponent } from './components/embedded/dashboard/dashboard.component'

import { BlobStorageUrlService } from './services/shared/blob-storage-url.service'
import { DialogYesnoComponent } from './components/shared/dialog-yesno/dialog-yesno.component'
import { DialogPauseAlertComponent } from './components/administration/aisettings-camera-control/dialog-pause-alert/dialog-pause-alert.component'
import { AutoSanityCheckComponent } from './components/administration/auto-sanity-check/auto-sanity-check.component'
import { SanityPlantComponent } from './components/administration/auto-sanity-check/sanity-plant/sanity-plant.component'


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication(msalConfig);
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();

  protectedResourceMap.set(protectedResources.client.endpoint, protectedResources.client.scopes);
  protectedResourceMap.set(protectedResources.vehicle.endpoint, protectedResources.vehicle.scopes);
  protectedResourceMap.set(protectedResources.security.endpoint, protectedResources.security.scopes);
  protectedResourceMap.set(protectedResources.realtime.endpoint, protectedResources.realtime.scopes);
  protectedResourceMap.set(protectedResources.general.endpoint, protectedResources.general.scopes);
  protectedResourceMap.set(protectedResources.userAdministration.endpoint, protectedResources.userAdministration.scopes);
  protectedResourceMap.set(protectedResources.realTimesTrucktDetail.endpoint, protectedResources.realTimesTrucktDetail.scopes);
  protectedResourceMap.set(protectedResources.realTimeTrucksByCheckpoint.endpoint, protectedResources.realTimeTrucksByCheckpoint.scopes);
  protectedResourceMap.set(protectedResources.sourceDeviceStatus.endpoint, protectedResources.sourceDeviceStatus.scopes);
  protectedResourceMap.set(protectedResources.Incidents.endpoint, protectedResources.Incidents.scopes);
  protectedResourceMap.set(protectedResources.incidentsTypes.endpoint, protectedResources.incidentsTypes.scopes);
  protectedResourceMap.set('/api/', protectedResources.Sites.scopes);
  protectedResourceMap.set('/api/', protectedResources.incidentsStatus.scopes);
 
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: loginRequest
  };
}

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  // fgsColor: '#113972',//'#00ACC1', // Color del spinner
  // pbColor: "#2e41d6", // Color de la barra de progreso
  // fgsType: 'three-bounce', // Tipo del spinner (ball-scale, three-bounce, etc.)
  // fgsSize: 60, // Tamaño del spinner
  // overlayColor: 'rgba(40,40,40,0.8)', // Color del fondo
  // hasProgressBar: true, // Habilitar barra de progreso
  // pbDirection: 'ltr', // Dirección de la barra de progreso (izquierda a derecha)
  // pbThickness: 5, // Grosor de la barra de progreso
};


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    MainDashboardComponent,
    RealTimeDashboardComponent,
    FilterPlateComponent,
    NotFoundComponent,
    TripDetailComponent,
    SidenavComponent,
    TruckEfficiencyDashboardComponent,
    PlantEfficiencyDashboardComponent,
    UserAdministrationComponent,
    CatalogueManagementComponent,
    ListPlatesComponent,
    TripDetailRealTimeComponent,
    TripDetailRtComponent,
    BrokenImageDirective,
    DetailTruckComponent,
    OrdinalDatePipe,
    OrderByPipe,
    ClientComponent,
    ClientNewUpdateComponent,
    VehicleComponent,
    TotalCountryDashboardComponent,
    HealthSafetyDashboardComponent,
    HealthSafetyControlTowerDashboardComponent,
    MinidashboardComponent,
    MinidashboardDzComponent,
    MinidashboardPpeComponent,
    MinidashboardUserComponent,
    MinidashboardEnvaseComponent,
    MinidashboardMateriasPrimasComponent,
    MinidashboardUserDzComponent,

    GridComponent,

    IncidentRecordComponent,
    CarouselIncidentRecordComponent,
    RejectIncidentsComponent,
    IncidentHealthSafetyControlTowerComponent,
    IncidentFormComponent,
    DialogFormConfirmComponent,
    ReasonSendMessageComponent,
    DialogIncidentCloseComponent,
    DialogYesnoComponent,
    DeviceManagementComponent,
    ModalReportingFieldsComponent,
    StatusCctvComponent,
    FieldServiceReviewComponent,
    ModalReportFormEditComponent,
    FilterComponentComponent,
    DevicesAvailabilityComponent,
    PerformanceMonitoringComponent,
    ModalPerformanceMonitoringComponent,
    AISettingsCameraControlComponent,
    SettingsCameraComponent,
    ModalSettingsCameraComponent,
    ModalPauseAlertComponent,
    DialogPauseAlertComponent,
    CatalogueDevicesComponent,
    SaveDeviceComponent,
    ConfirmDialogComponent,
    ModalSettingsCameraComponent,
    ConfirmDialogAlertsComponent,
    SettingsUpdateDevicesComponent,
    DashboardComponent,
    AutoSanityCheckComponent,
    SanityPlantComponent
    ],
  imports: [
    
    MatButtonModule,
     MatSnackBarModule,
     NoopAnimationsModule,
    MatTabsModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    BrowserModule,
    AppRoutingModule,
    MsalModule,
    HttpClientModule,
    ReactiveFormsModule,
    MaterialModule,
    NgImageSliderModule,
    LayoutModule,
    GoogleMapsModule,
    MatRadioModule,
    NgxMaterialTimepickerModule,
    MatFormFieldModule, 
    MatChipsModule, 
    MatIconModule, 
    MatAutocompleteModule,
    MatDialogModule,
    MatButtonModule,
    MatSlideToggleModule,
    HttpClientJsonpModule,
    // NgxChartsModule,
    // Chart,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    UserDataModule,
    NgxPaginationModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig)
   
    
     
    
  ],
  schemas: [],
  providers: [
    // provideClarity({
    //   enabled: true,
    //   projectId: 'lz92c71h9u',
    // }),
  
    { provide: LOCALE_ID, useValue: "en" },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide:HTTP_INTERCEPTORS,
      useClass:LoadingInterceptor,
      multi:true

    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
  
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    CookieService,
    BlobStorageUrlService
    
  
    
  ],
  bootstrap: [AppComponent,
    MsalRedirectComponent,
  ]
})
export class AppModule { }


